module.exports = __webpack_public_path__ + "bf4a35d5f5fbb287d3be53dbb8190b08.MP3";